export const stiggDocsMainPage = 'https://docs.stigg.io/';
export const gettingStartedDocsLink = 'https://docs.stigg.io/docs/modeling-your-pricing';

export const integratingStiggSdksIntoYourCodebaseLink = 'https://docs.stigg.io/docs/codebase-integration-overview';
